import React from 'react';

const footerLinks = [
  { label: 'Features', href: '#features' },
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'FAQ', href: '#faq' },
  { label: 'Contact', href: '#contact' },
];

export default function FooterSection() {
  return (
    <footer data-testid="footer-section" className="border-t border-white/10 relative overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16 lg:py-24">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
          {/* Logo */}
          <div>
            <img src="/logo.png" alt="webridgeAI" className="h-8 w-auto mb-3" />
            <p className="text-sm text-neutral-500" style={{ fontFamily: 'Manrope, sans-serif' }}>
              AI voice agents for Calgary real estate.
            </p>
          </div>

          {/* Links */}
          <div className="flex flex-wrap gap-6">
            {footerLinks.map((link) => (
              <a
                key={link.label}
                href={link.href}
                className="text-sm text-neutral-500 hover:text-white transition-colors duration-200"
                style={{ fontFamily: 'Manrope, sans-serif' }}
              >
                {link.label}
              </a>
            ))}
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-white/5 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-neutral-600" style={{ fontFamily: 'Manrope, sans-serif' }}>
            &copy; {new Date().getFullYear()} weBridge.ai. All rights reserved.
          </p>
          <div className="flex gap-6">
            <a href="#" className="text-xs text-neutral-600 hover:text-neutral-400 transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="text-xs text-neutral-600 hover:text-neutral-400 transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>

      {/* Background logo decoration */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 pointer-events-none select-none">
        <img src="/logo.png" alt="" className="h-32 lg:h-48 w-auto opacity-[0.06]" />
      </div>
    </footer>
  );
}
